import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import device from './plugins/device'
import './plugins/firebase'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'

loadFonts()

createApp(App).use(store)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(device)
  .use(VueAxios, axios)
  .use()
  .mount('#app')
